import { render, staticRenderFns } from "./static-content-wrapper.vue?vue&type=template&id=dceee18a&scoped=true"
import script from "./static-content-wrapper.vue?vue&type=script&lang=js"
export * from "./static-content-wrapper.vue?vue&type=script&lang=js"
import style0 from "./static-content-wrapper.vue?vue&type=style&index=0&id=dceee18a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceee18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dceee18a')) {
      api.createRecord('dceee18a', component.options)
    } else {
      api.reload('dceee18a', component.options)
    }
    module.hot.accept("./static-content-wrapper.vue?vue&type=template&id=dceee18a&scoped=true", function () {
      api.rerender('dceee18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/static-content-wrapper.vue"
export default component.exports